<template>
  <div class="styled-radio-container styled-radio-container--ou-donation row">
  
    <div
      v-for="([amount, description], index)  of amounts.slice(3, 6)"
      :key="`${amount}_${index}`"
      class="amount-row"
      :data-amount="amount"
    >
      <input
        :id="`${amount}_${index}`"
        type="radio"
        class="amount"
        @click="
          selectedAmount = amount;
          selectedDescription = description;
        "
        :checked="(selectedAmount == amount)"
        @change="emitValue"
      />
      <FormLabel :for="`${amount}_${index}`">
        <MoneyFormat
          class="label-amount"
          :class="{noDescription: !description}"
          :value="amount"
          :currencyCode="form.currency"
          :hide-subunits="false"
        />
        <span class="label-description" v-if="description" v-html="description"></span>
      </FormLabel>
    </div>

    <div
      class="amount_other__wrapper amount-row"
      v-if="!nocustom"
      :class="form.currency == 'ILS' ? 'shekel' : ''"
    >
      <input
        id="amount_other_check"
        type="radio"
        class="amount"
        :checked="customSelected"
        @click="customSelected = true"
      />
      <input
        id="amount_other"
        type="number"
        min="1"
        name="amount_other"
        :placeholder="lang == 'he'? 'אחר' : 'Other'"
        v-model="customAmount"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  props: ["nocustom","lang"],
  emits: ["update:emittedDescription"],
  setup(props, { emit }) {
    const { setValue, form, settings } = usePaymentForm();

    const emittedDescription = ref<string | null>(null);

    const emitValue = () => {
      emit("update:emittedDescription", selectedDescription.value);
    };

    const selectedAmount = ref();
    const selectedDescription = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;

        customAmount.value = null;

        setValue("amount", "" + selectedAmount);
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const params = queryParams();

    if (params.amount) {
      //@ts-ignore
      if (
        //@ts-ignore
        amounts.value.includes(+params.amount) ||
        //@ts-ignore
        amounts.value.map((x) => x[0]).includes(+params.amount)
      ) {
        selectedAmount.value = params.amount;
      } else {
        customAmount.value = params.amount;
      }
    } else {
      // Set default to 18.4
      selectedAmount.value = 18.4;
    }

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      emitValue,
      emittedDescription,
      clearOutSelectedValue,
      customSelected,
      selectedDescription,
      params,
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  input[type="radio"]:checked + label {
    background: #0075ff;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0367de;
    border-color: #1849ff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.shekel {
      &:before {
        content: "₪";
        position: absolute;
      }
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: bold;
  display: inline-block;
  padding: 10px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;

  &.noDescription {
    min-width: 100%;
  }
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
.label-description {
  font-weight: normal;
  padding: 10px;
  align-items: center;
  justify-content: center;
  height: 100%;
  display: flex;
  font-size: 12px;
  line-height: 1.4;
}
</style>
